import React from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme, IconButton, Box } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import Logo from '../Logo';
import history from '../../history';

interface MenuLogoProps {
  menuToggleButton?: boolean;
  menuClickCallback?: () => void;
  isShowLogo?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuButtonContainer: {
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    menuButton: {
      paddingLeft: 0,
    },
    icon: {
      marginRight: theme.spacing(0.5),
    },
    logo: {
      cursor: 'pointer',
      fontSize: '35px',
      color: theme.palette.primary.contrastText,
    },
  }),
);

const MenuLogo = (props: MenuLogoProps) => {
  const {
    menuToggleButton = true,
    isShowLogo = true,
    menuClickCallback,
  } = props;
  const classes = useStyles();
  const routeHome = () => {
    // TODO: we need to fix this place
    // history could be undefined
    /* eslint-disable @typescript-eslint/ban-ts-ignore */
    // @ts-ignore
    history.push('/');
  };
  return (
    <>
      {menuToggleButton ? (
        <div className={classes.menuButtonContainer}>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={menuClickCallback}
            id="menu-hamburger"
          >
            <MenuIcon />
          </IconButton>
        </div>
      ) : null}
      {isShowLogo && (
        <Box className={classes.logo} onClick={() => routeHome()}>
          <Logo />
        </Box>
      )}
    </>
  );
};

export default MenuLogo;
